import { useState, useCallback } from "react";
import axios from "axios";
import { BASE_API } from "@/constants";

/**
 * Custom hook for posting data.
 *
 * @param {string} url - The API endpoint URL
 */
const usePostData = (url) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [response, setResponse] = useState(null);

    const mutate = useCallback(
        async (data, options = {}) => {
            setIsLoading(true);
            setError(null);
            const method = options.method || "post";

            try {
                const res = await axios({
                    method,
                    url: `${BASE_API}/${url}`,
                    data,
                });
                setResponse(res.data);
                if (options.onSuccess) {
                    options.onSuccess(res.data);
                }
                return res.data;
            } catch (err) {
                setError(err);
                if (options.onError) {
                    options.onError(err);
                }
                console.error("Error posting data:", err);
            } finally {
                setIsLoading(false);
            }
        },
        [url],
    );

    return { mutate, isLoading, error, response };
};

export default usePostData;
